import answer from './answer';
import assignReviewers from './assignReviewers';
import calibration from './calibration';
import common from './common';
import compensation from './compensation';
import competencies from './competencies';
import competenciesTab from './competencies/competenciesTab';
import competenciesLevels from './competencies/levels';
import competenciesNavigator from './competencies/navigator';
import competenciesTranslations from './competencies/translations';
import competencyProfiles from './competencyProfiles';
import cycleEvaluationCommunications from './cycleEvaluation/communications';
import cycleEvaluationCycleInformation from './cycleEvaluation/cycleInformation';
import cycleEvaluationDashboard from './cycleEvaluation/dashboard';
import cycleEvaluationDeadlines from './cycleEvaluation/deadlines';
import cycleEvaluationDefineAudience from './cycleEvaluation/defineAudience';
import cycleEvaluationEvaluationElements from './cycleEvaluation/evaluationElements';
import cycleEvaluationGroupStepper from './cycleEvaluation/groupStepper';
import cycleEvaluationSchedule from './cycleEvaluation/schedule';
import cycleEvaluationSelectEvaluators from './cycleEvaluation/selectEvaluators';
import cycleEvaluationSelectTemplate from './cycleEvaluation/selectTemplate';
import cycleEvaluationStepper from './cycleEvaluation/stepper';
import cycleEvaluationSuccessMessage from './cycleEvaluation/successMessage';
import dynamicTags from './dynamicTags';
import employeePortal from './employeePortal';
import employeePortalRecognitions from './employeePortalRecognitions';
import employeePortalSummary from './employeePortalSummary';
import employeesWithoutObjectives from './employeesWithoutObjectives';
import errors from './errors';
import evaluation360AssignReviewers from './evaluation360/assignReviewers';
import evaluation360Dashboard from './evaluation360/dashboard';
import evaluation360Priorities from './evaluation360/priorities';
import evaluation360Questionnaire from './evaluation360/questionnaire';
import evaluation360ScheduleCreation from './evaluation360/scheduleCreation';
import evaluation360SelectReviewee from './evaluation360/selectReviewee';
import evaluation360SelectTemplate from './evaluation360/selectTemplate';
import evaluation360Stepper from './evaluation360/stepper';
import evaluation360SuccessMessage from './evaluation360/successMessage';
import feedbackComments from './feedbackComments';
import feedbackPrivacy from './feedbackPrivacy';
import frequency from './frequency';
import home from './home';
import managerAssessmentEvaluation from './managerAssessment/evaluation';
import managerAssessmentResults from './managerAssessment/results';
import managerAssessmentSetup from './managerAssessment/setup';
import meetingAgenda from './meetingAgenda';
import objectivePeriods from './objectivePeriods';
import objectives from './objectives';
import performancePro from './performancePro';
import performanceProfile from './performanceProfile';
import pillars from './pillars';
import postReviewMeeting from './postReviewMeeting';
import postReviewPrepareMeeting from './postReviewPrepareMeeting';
import postReviewResults from './postReviewResults';
import question from './question';
import questionResult from './questionResult';
import reports from './reports';
import results from './results';
import reviewAnswer from './reviewAnswer';
import selfAssessmentStepper from './selfAssessment/stepper';
import selfAssessmentSuccessMessage from './selfAssessment/successMessage';
import startReview from './startReview';
import strategicVision from './strategicVision';
import templateManagement from './templateManagement';
import thematicMeetings from './thematicMeetings';
import visionValues from './visionValues';

export default {
    answer,
    assignReviewers,
    calibration,
    common,
    competencies,
    competenciesLevels,
    competenciesNavigator,
    competenciesTab,
    competenciesTranslations,
    cycleEvaluationCommunications,
    cycleEvaluationCycleInformation,
    cycleEvaluationDeadlines,
    cycleEvaluationDefineAudience,
    cycleEvaluationEvaluationElements,
    cycleEvaluationSelectEvaluators,
    employeePortalRecognitions,
    employeePortalSummary,
    employeesWithoutObjectives,
    errors,
    cycleEvaluationGroupStepper,
    cycleEvaluationStepper,
    cycleEvaluationDashboard,
    cycleEvaluationSchedule,
    cycleEvaluationSelectTemplate,
    cycleEvaluationSuccessMessage,
    dynamicTags,
    employeePortal,
    evaluation360AssignReviewers,
    evaluation360Dashboard,
    evaluation360Questionnaire,
    evaluation360SelectReviewee,
    evaluation360SelectTemplate,
    evaluation360ScheduleCreation,
    evaluation360Stepper,
    selfAssessmentStepper,
    selfAssessmentSuccessMessage,
    evaluation360Priorities,
    evaluation360SuccessMessage,
    feedbackComments,
    feedbackPrivacy,
    frequency,
    home,
    question,
    questionResult,
    startReview,
    reviewAnswer,
    managerAssessmentSetup,
    managerAssessmentEvaluation,
    managerAssessmentResults,
    templateManagement,
    competencyProfiles,
    reports,
    compensation,
    results,
    postReviewResults,
    postReviewPrepareMeeting,
    postReviewMeeting,
    meetingAgenda,
    thematicMeetings,
    visionValues,
    performancePro,
    performanceProfile,
    pillars,
    objectivePeriods,
    objectives,
    strategicVision,
};
